export default __webpack_public_path__ + "static/media/copy.d215f482.png";